module.exports = __webpack_public_path__ + "media/vuvuzela.eab4ca20.mp3";